import loadable from '@loadable/component';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "__notifications-preferences" */
      './NotificationsPreferencesMain'
    ),
);
